import { useFormik } from "formik";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import * as api from "helper/helper";
import toast from "react-hot-toast";
import { userFormValidate } from "../../../../helper/validate";
import invalidClass, { formikExtra } from "../../helperFunctions/helpers";

const ChangeLevelModal = forwardRef(({ item, onOk, reloadUsuarios }, ref) => {
  const modalButtonRef = useRef();

  const [niveles, setNiveles] = useState([]);

  const [canSave, setCanSave] = useState(false);

  useImperativeHandle(ref, () => ({
    toggleModal: () => {
      formik?.resetForm();
      modalButtonRef.current.click();

      setCanSave(false);
    },
  }));

  //
  //let montoActual = item?.actual ?? 0;
  let initialValues = {
    nivel: 0,
    mensaje: "",
  };

  if (item) {
    initialValues = {
      nivel: 0,
      mensaje: "",
    };
  }

  useEffect(() => {
    api
      .niveles()
      .then((response) => {
        //setNiveles([...niveles, ...response.data]);
        setNiveles([
          { id: 0, nombre: "Selecciona un Nivel..." },
          ...response.data,
        ]);
        console.log(response.status);
      })
      .catch((e) => {
        console.log(e); // "oh, no!"
      });
  }, []);

  useEffect(() => {
    setCanSave(false);
  }, [item]);

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validate: userFormValidate,
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values) => {},
  });

  const nivelActual = item?.nivel?.nombre ?? "";

  return (
    <>
      {/*<!-- Button trigger modal -->*/}
      <button
        ref={modalButtonRef}
        type="button"
        className="btn btn-primary"
        data-bs-toggle="modal"
        data-bs-target="#staticBackdropChangeLevelLimit"
        hidden
      >
        Launch static backdrop modal
      </button>

      {/*<!-- Modal -->*/}
      <div
        className="modal fade"
        id="staticBackdropChangeLevelLimit"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropChangeLevelLimitLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5
                className="modal-title"
                id="staticBackdropChangeLevelLimitLabel"
              >
                Solicitar Cambio de Nivel
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body">
              {/*<div className="alert alert-warning" role="alert">
                Ya existe una peticion de cambio de Nivel de <b>basico</b> a{" "}
                <b>Oro</b> en <b>Pendiente de aprobación.</b>
                <br />
                <small>
                  Si Aplica a una nuevo cambio de Nivel, la anterior se
                  cancelara
                </small>
              </div>*/}
              <form className="row" onSubmit={formik.handleSubmit}>
                <div className="mb-3">
                  <div className="mb-3 row">
                    <div className="col align-self-start">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        Nivel Actual
                      </label>

                      <input
                        type="text"
                        className="form-control"
                        id="validationName"
                        aria-describedby="emailHelp"
                        defaultValue={nivelActual}
                        aria-label="readonly input example"
                        readOnly
                      />
                      <div className="valid-feedback"></div>
                      <div className="invalid-feedback">
                        {formik.errors.montoActual}
                      </div>
                    </div>

                    <div className="col align-self-start">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        Nivel
                      </label>
                      <select
                        className={`form-select ${invalidClass(
                          formik.errors.nivel,
                        )}`}
                        id="inputGroupSelect01"
                        {...formik.getFieldProps("nivel")}
                        onChange={(e) => {
                          const option = parseInt(e.target.value);
                          formik.setFieldValue("nivel", option);

                          setCanSave(option > 0);
                        }}
                      >
                        {niveles.map((item) => {
                          // <option selected>Selecciona un nivel...</option>
                          //  const isSelected = item.id === selectedNivelId;
                          return (
                            <option key={item.id} value={item.id}>
                              {item.nombre}
                            </option>
                          );
                        })}
                      </select>
                      <div className="valid-feedback">Looks good! WPWPWPW</div>
                      <div className="invalid-feedback">
                        {formik.errors.nivel}
                      </div>
                    </div>
                  </div>

                  <div className="mb-3">
                    <div className="form-floating">
                      <textarea
                        className="form-control"
                        placeholder="Deja Mensaje para Revisión"
                        id="floatingTextarea2"
                        {...formik.getFieldProps("mensaje")}
                        {...formikExtra.upperCase("mensaje", formik)}
                        style={{ height: "100px" }}
                      ></textarea>
                      <label htmlFor="floatingTextarea2">Mensaje</label>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Cancelar
              </button>
              <button
                className="btn btn-primary"
                type="button"
                disabled={!canSave}
                onClick={async () => {
                  const value = formik.getFieldProps("nivel").value;
                  const asociadoId = item.id;

                  //
                  const toastId = toast.loading(
                    "Solicitando Cambio de Nivel...",
                  );
                  const responseCrearSolicitud = await api
                    .asociadosSolicitudesCreate({
                      asociadoId: asociadoId,
                      tipoDeSolicitud: "Nivel",
                      fecha: new Date().toJSON(),
                      mensaje: formik.values.mensaje,
                      nivelSolicitadoId: value,
                    })
                    .catch((e) => {
                      toast.dismiss(toastId);
                      if (e.esError && e.codigoError && e.mensaje) {
                        toast.error(
                          `Error al Solicitar Cambio Nivel. ${e.mensaje}`,
                        );
                        return;
                      }
                      toast.error("Error al Solicitar Cambio Nivel. ");
                    });

                  toast.dismiss(toastId);
                  if (!responseCrearSolicitud) return;
                  toast.success(
                    <b>Se realizo solicitud de cambio en Asociado</b>,
                  );

                  //
                  modalButtonRef.current.click();
                }}
              >
                Solicitar
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});

export default ChangeLevelModal;
